'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var bumbag = require('bumbag');
var reactUse = require('react-use');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function NetworkCheck() {
  var _useNetwork = reactUse.useNetwork(),
      online = _useNetwork.online;

  var _React$useState = React__default["default"].useState(false),
      showCallout = _React$useState[0],
      setShowCallout = _React$useState[1];

  React__default["default"].useEffect(function () {
    if (typeof online === 'boolean') {
      setShowCallout(!online);
    }
  }, [online]);
  return (
    /*#__PURE__*/
    // @ts-expect-error TS(2741): Property 'baseId' is missing in type '{ children: ... Remove this comment to see the full error message
    React__default["default"].createElement(bumbag.Callout.Overlay, {
      visible: showCallout,
      showCloseButton: true,
      onClickClose: function onClickClose() {
        return setShowCallout(false);
      },
      title: "Internet connection issues",
      type: "danger"
    }, "We are having trouble trying to establish an internet connection. ", /*#__PURE__*/React__default["default"].createElement("br", null), "Please check if your computer is connected to the internet &", ' ', /*#__PURE__*/React__default["default"].createElement(bumbag.Link, {
      onClick: function onClick() {
        return window.location.reload(true);
      }
    }, "click here"), " to try again.")
  );
}

exports["default"] = NetworkCheck;
